export const getProductSku = state => state.productSku;
export const getProductId = state => state.productId;
export const getProductName = state => state.productName;
export const getProductColor = state => state.desiredColor;
export const getDesiredQuantity = state =>
  state.desiredQuantity ? state.desiredQuantity : 1;
export const getGroupsEnabled = state => state.groups_enabled;
export const getImageLink = state => {
  let imageUrl;
  if (state.desiredColor) {
    state.combinations.forEach(c => {
      if (c.image && c.color == state.desiredColor) {
        imageUrl = c.image;
      }
    });
  }
  return !imageUrl ? state.imageLink : imageUrl;
};
export const getProductCombinations = state => state.combinations;
export const getProducts = state => state.products;
export const primaryColor = state => {
  return {
    color: state.primaryColor,
    fill: state.primaryColor
  };
};
export const primaryBgColor = state => {
  return {
    backgroundColor: state.primaryColor
  };
};
export const secondaryColor = state => {
  return {
    color: state.secondaryColor,
    fill: state.secondaryColor
  };
};
export const secondaryBgColor = state => {
  return {
    backgroundColor: state.secondaryColor
  };
};
export const language = state => state.language;
